import React, { useState } from "react";
import Select from "react-select";
import {
  FaPhoneAlt,
  FaUser,
  FaBirthdayCake,
  FaVenusMars,
  FaHeart,
  FaGlobe,
  FaLanguage,
  FaTint,
} from "react-icons/fa";
import { countries } from "../../_helper/constant/CountryList";
import CuSpinner from "../../common_component/component/CuSpinner";
import { languageOptions } from "../../_helper/constant/LanguagesList";
import { bloodGroupOptions } from "../../_helper/constant/BloodGroupList";

const countryOptions = countries.map((country) => ({
  value: country,
  label: country,
}));

export default function PersonalDetails({
  data,
  onChange,
  existingUser = [],
  isLoading,
}) {
  const [isAddingNewMember, setIsAddingNewMember] = useState(false);

  console.log(existingUser);
  const handleUserSelect = (selectedOption) => {
    if (selectedOption) {
      onChange({
        ...data,
        full_name: selectedOption.label,
        gender: selectedOption.gender,
        dob: selectedOption.dob,
        user: selectedOption.user,
        id: selectedOption.value,
      });
      setIsAddingNewMember(false);
    } else {
      setIsAddingNewMember(true);
    }
  };

  const handleAddNewMember = (e) => {
    const { name, value } = e.target;
    onChange({
      ...data,
      [name]: value,
    });
  };

  const handleAddNewRegistration = (e) => {
    const { name, value } = e.target;
    onChange({
      ...data,
      [name]: value,
      isParent: true,
      family_id: value?.user_details?.phone,
    });
  };

  const handlePhoneChange = (e) => {
    const phone = e.target.value;
    console.log(phone);
    onChange({ ...data, phone: phone });

    // Reset fields if the phone number becomes invalid or too short
    if (phone.length < 10) {
      onChange({
        phone,
        full_name: "",
        gender: "",
        dob: "",
        user: null,
        id: null,
        marital_status: "",
        country: "",
        language: "",
        blood_group: "",
      });
      setIsAddingNewMember(false);
    }
  };

  return (
    <div className="">
      <h2 className="text-2xl font-bold mb-6 text-gray-700">
        Personal Details
      </h2>

      {/* Mobile Number Input */}
      <div className="mb-8">
        <label className="block mb-2 text-gray-600 font-medium">
          Mobile Number
        </label>
        <div className="flex items-center bg-white border border-gray-300 rounded-md p-2 shadow-sm">
          <FaPhoneAlt className="text-gray-500 mr-2" />
          <input
            type="tel"
            value={data.phone || ""}
            onChange={(e) => {
              // Ensure only digits and max 10 characters
              const value = e.target.value.slice(0, 10).replace(/\D/g, "");
              handlePhoneChange({ target: { value } });
            }}
            className="flex-grow bg-transparent border-none focus:outline-none text-gray-700"
            placeholder="Enter Mobile Number"
          />
          {isLoading && (
            <div className="ml-2">
              <CuSpinner />
            </div>
          )}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-6">
        {/* Full Name Dropdown or Add New Member */}
        <div>
          <label className="block mb-1 text-gray-600 font-medium">
            Full Name
          </label>
          <div
            className={`flex items-center bg-white ${isAddingNewMember || existingUser.length === 0 ? "border border-gray-300" : ""} rounded-md p-2 shadow-sm`}
          >
            <FaUser className="text-gray-500 mr-2" />
            {isAddingNewMember || existingUser.length === 0 ? (
              <input
                type="text"
                name="full_name"
                value={data.full_name || ""}
                onChange={handleAddNewMember}
                className="flex-grow bg-transparent border-none focus:outline-none text-gray-700"
                placeholder="Enter Full Name"
              />
            ) : isLoading ? (
              <p className="text-gray-500">Loading...</p>
            ) : (
              <div className="flex-grow">
                <Select
                  options={[
                    ...existingUser.map((user) => ({
                      value: user.id,
                      label: user.label,
                      gender: user.gender,
                      dob: user.dob,
                      user: user.user,
                    })),
                    { value: "new", label: "Add New Member" },
                  ]}
                  value={existingUser.find(
                    (option) => option.value === data.selectedPatient
                  )}
                  onChange={(selectedOption) =>
                    selectedOption?.value === "new"
                      ? handleUserSelect(null)
                      : handleUserSelect(selectedOption)
                  }
                  placeholder="Select or Add Member"
                  // isClearable
                  classNamePrefix="react-select"
                />
              </div>
            )}
          </div>
        </div>

        {/* Gender */}
        <div>
          <label className="block mb-1 text-gray-600 font-medium">Gender</label>
          <div className="flex items-center bg-white border border-gray-300 rounded-md p-2 shadow-sm">
            <FaVenusMars className="text-gray-500 mr-2" />
            {isAddingNewMember ? (
              <select
                name="gender"
                value={data.gender || ""}
                onChange={handleAddNewMember}
                className="flex-grow bg-transparent border-none focus:outline-none text-gray-700"
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>
            ) : (
              <input
                type="text"
                value={data.gender || ""}
                readOnly
                className="flex-grow bg-transparent border-none focus:outline-none text-gray-700"
                placeholder="Gender"
              />
            )}
          </div>
        </div>

        {/* Date of Birth */}
        <div>
          <label className="block mb-1 text-gray-600 font-medium">
            Date of Birth
          </label>
          <div className="flex items-center bg-white border border-gray-300 rounded-md p-2 shadow-sm">
            <FaBirthdayCake className="text-gray-500 mr-2" />
            {isAddingNewMember ? (
              <input
                type="date"
                name="dob"
                value={data.dob || ""}
                onChange={handleAddNewMember}
                className="flex-grow bg-transparent border-none focus:outline-none text-gray-700"
              />
            ) : (
              <input
                type="date"
                value={data.dob || ""}
                readOnly
                className="flex-grow bg-transparent border-none focus:outline-none text-gray-700"
                placeholder="Date of Birth"
              />
            )}
          </div>
        </div>

        {/* Marital Status */}
        <div>
          <label className="block mb-1 text-gray-600 font-medium">
            Marital Status
          </label>
          <div className="flex items-center bg-white border border-gray-300 rounded-md p-2 shadow-sm">
            <FaHeart className="text-gray-500 mr-2" />
            <select
              name="marital_status"
              value={data.marital_status || ""}
              onChange={handleAddNewMember}
              className="flex-grow bg-transparent border-none focus:outline-none text-gray-700"
            >
              <option value="">Select Status</option>
              <option value="single">Single</option>
              <option value="married">Married</option>
              <option value="divorced">Divorced</option>
              <option value="widowed">Widowed</option>
            </select>
          </div>
        </div>

        {/* Nationality */}
        <div>
          <label className="block mb-1 text-gray-600 font-medium">
            Nationality
          </label>
          <div className="flex items-center">
            <FaGlobe className="text-gray-500 mr-2" />
            <div className="flex-grow">
              <Select
                options={countryOptions}
                value={countryOptions.find(
                  (option) => option.value === data.country
                )}
                onChange={(option) =>
                  onChange({ ...data, country: option?.value })
                }
                placeholder="Select Nationality"
                classNamePrefix="react-select"
              />
            </div>
          </div>
        </div>

        {/* Language Preference */}
        <div>
          <label className="block mb-1 text-gray-600 font-medium">
            Language Preference
          </label>
          <div className="flex items-center">
            <FaLanguage className="text-gray-500 mr-2" />
            <div className="flex-grow">
              <Select
                options={languageOptions}
                value={languageOptions.find(
                  (option) => option.value === data.language
                )}
                onChange={(option) =>
                  onChange({ ...data, language: option?.value })
                }
                placeholder="Select Language Preference"
                classNamePrefix="react-select"
              />
            </div>
          </div>
        </div>

        {/* Blood Group */}
        <div>
          <label className="block mb-1 text-gray-600 font-medium">
            Blood Group
          </label>
          <div className="flex items-center">
            <FaTint className="text-gray-500 mr-2" />
            <div className="flex-grow">
              <Select
                options={bloodGroupOptions}
                value={bloodGroupOptions.find(
                  (option) => option.value === data.blood_group
                )}
                onChange={(option) =>
                  onChange({ ...data, blood_group: option?.value })
                }
                placeholder="Select Blood Group"
                classNamePrefix="react-select"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
